<template>
  <form
    class="login-form absa-form"
    @submit.prevent="proceed"
    v-show="state.loaded"
  >
    <div class="content-section">
      <absa-pay-logo />

      <h3 style="text-align: center">Verify your Absa account</h3>
      <p>Enter your registered {{ selectedInputConfig.label }} to verify</p>
    </div>
    <div class="inputs-section">
      <!-- User Input -->
      <div class="input-block">
        <pf-input
          id="absa"
          v-model="state.identifierValue"
          :disabled="isAbsaPayHighRiskTransaction"
        >
          <span>{{ selectedInputConfig.label }}</span>
        </pf-input>
        <div class="pay-button">
          <proceed-button
            :is-proceed-enable="canProceed()"
            :is-loading="this.isLoading"
          />
        </div>
      </div>
    </div>
    <div class="inputs-switch" v-if="!isAbsaPayHighRiskTransaction">
      <p>I would like to use my</p>
      <span
        v-for="(input, key) in inputConfigs.filter(
          ({ key: configKey }) => configKey !== this.state.identifierKey
        )"
        :key="key"
      >
        <span @click="setIdentifierKey(input.key)" class="underlined">{{
          input.label
        }}</span>
        <!-- Minus 2 from count to take into account that 1 option will be active -->
        <span v-if="key !== inputConfigs.length - 2"> | </span>
      </span>
    </div>
    <br />
    <div class="notification">
      <p class="note">
        <span><img src="../assets/images/info.svg" alt="info" /></span> Please
        note
      </p>
      <p class="disclaimer">
        Payfast by Network and Absa are enabling a safe and secure method of
        paying from your bank account. Payfast by Network will not access your
        bank account on your behalf.
      </p>
    </div>
  </form>
</template>

<script>
import { formMixin } from '@/mixins/formMixin.js'
import { mapState } from 'vuex'
import PfCustomInput from '../components/CustomInput.vue'
import axios from '@/wrapper'
import loadingManager from '@/LoadingManager'
import AbsaPayLogo from '@/components/AbsaPayLogo'
import Constants from '@/constants'
import { maskInput } from '@/utils'

const initialState = {
  loaded: false,
  identifierKey: 'ACCOUNT',
  identifierValue: '',
}

export default {
  name: 'AbsaPayBankForm',
  mixins: [formMixin],
  components: {
    pfInput: PfCustomInput,
    AbsaPayLogo,
  },
  data() {
    return {
      state: initialState,
    }
  },
  async mounted() {
    this.createState()
  },
  computed: {
    ...mapState('transaction', ['transaction']),
    ...mapState('merchantSettings', ['isAbsaPayHighRiskTransaction']),
    ...mapState('signalRMessage', ['message']),
    inputConfigs() {
      return Constants.bankInputConfigs[this.transaction.acquirerCode]
    },
    inputConfigsForMerchant() {
      if (this.isAbsaPayHighRiskTransaction) {
        return this.inputConfigs.filter((input) => input.isHighRiskKey)
      }
      return this.inputConfigs
    },
    selectedInputConfig() {
      return this.inputConfigs.find(
        (input) => input.key === this.state.identifierKey
      )
    },
    initialIdentifierKey() {
      let config = this.inputConfigs[0]
      if (this.isAbsaPayHighRiskTransaction)
        config = this.inputConfigs.find((input) => input.isHighRiskDefault)
      return config.key
    },
    isProceedEnable() {
      return this.canProceed()
    },
  },
  methods: {
    createState() {
      this.state = {
        loaded: true,
        identifierKey: this.initialIdentifierKey,
        identifierValue: this.isAbsaPayHighRiskTransaction
          ? maskInput(this.transaction.idNumber)
          : '',
      }
    },
    validateRegex() {
      const valueToCheck = this.isAbsaPayHighRiskTransaction
        ? this.transaction.idNumber
        : this.state.identifierValue
      return this.selectedInputConfig.regex.test(valueToCheck)
    },
    canProceed() {
      return this.validateRegex()
    },
    setIdentifierKey(key) {
      this.state.identifierKey = key
    },
    async proceed() {
      if (!this.canProceed()) {
        return false
      }
      this.$emit('closeErrorMessage')
      let errorMessage = ''
      this.isLoading = true

      await axios
        .post('bankApi/absaPay/consent', {
          transactionId: this.transaction.id,
          IdentifierKey: this.state.identifierKey,
          IdentifierValue: this.isAbsaPayHighRiskTransaction
            ? this.transaction.idNumber
            : this.state.identifierValue,
        })
        .then((response) => {
          if (response.data.HasErrors) {
            errorMessage =
              response.data.ErrorMessages[0].ErrorMessage ?? errorMessage
          } else {
            this.message.instruction.message =
              'Please wait while we connect you to Absa'
            loadingManager.setLoading(true)
          }
        })
        .catch((err) => {
          this.$handleException({ err, transactionId: this.transaction.id })
        })

      if (errorMessage !== '') {
        this.$emit('setError', errorMessage)
        this.isLoading = false
      }
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.absa-form {
  .notification {
    margin: 0 auto;
    text-align: center;
    border-radius: 8px;
    background: #d2cdcd4d;
    padding: 1px 20px;
    max-width: 320px;

    .note {
      font-weight: 700;
    }

    .disclaimer {
      font-size: 12px;
    }
  }

  .input__label span {
    font-size: 14px;
    font-weight: bold;
  }

  .content-section {
    h3 {
      text-align: center;
      font-weight: 700;
    }

    p {
      text-align: center;
      font-size: 14px;
    }
  }

  .pay-button {
    justify-content: center;
    min-width: 320px;
  }

  .input-block {
    align-items: center;
  }
  .inputs-switch {
    font-family: Founders Grotesk, serif;
    font-weight: 400;
    font-size: 16px;
    text-align: center;

    .underlined {
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
